var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"common-form"},[_vm._v("商品信息")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品名称"}},[_c('p',{staticClass:"fb"},[_vm._v(_vm._s(_vm.form.product_name))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"商品图片"}},[_c('img',{attrs:{"src":_vm.form.product_image,"width":"80"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d061e9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/advance/product/part/Info.vue
// module id = null
// module chunks = 